import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  invited: {
    color: '#dfbb13',
  },
  preparing: {
    color: '#989bc9',
  },
  readyToPlay: {
    color: theme.palette.success.light,
  },
  win: {
    color: theme.palette.success.light,
  },
  lose: {
    color: theme.palette.error.light,
  },
  tied: {
    color: theme.palette.grey['500'],
  },
  forfeit: {
    color: theme.palette.error.light,
  },
  aborted: {
    color: theme.palette.grey['500'],
  },
  default: {},

  icon: {
    marginTop: theme.spacing(-0.25),
    marginRight: theme.spacing(0.5),
  },
}));
